export default __webpack_public_path__ + "7f6d560acc550360d6ebb8ebdcb6d234.ttf";